import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MegaMenuComponent } from './mega-menu.component';
import { MatButtonModule } from '@angular/material/button';
import { RouterModule } from '@angular/router';
import { MatIconModule } from '@angular/material/icon';
import {TranslateModule} from "@ngx-translate/core";
import {TooltipModule} from "ng2-tooltip-directive";


@NgModule({
  declarations: [MegaMenuComponent],
    imports: [
        CommonModule,
        MatButtonModule,

        RouterModule,
        MatIconModule,
        TranslateModule,
        TooltipModule
    ],
  exports: [MegaMenuComponent]
})
export class MegaMenuModule { }
